// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateFacetFilterText = text => ({
    text,
    type: actions.UPDATE_TCSM_AUDIT_FACET_FILTER_TEXT
});



// WEBPACK FOOTER //
// ./src/tcsm/audits/action-creators/facet-filter-text.js